import { View } from "react-native";
import { UrgentConcernStatusEnum } from "app/services/api/types/shiftHandover/enums/UrgentConcernStatusEnum";
import { UrgentConcernsTable } from "../organisms/UrgentConcernsTable";
import { useUrgentConcernsWithOffline } from "app/features/offline/hooks/useUrgentConcernsWithOffline";
import LoadingSpinner from "ui/atoms/spinner/LoadingSpinner";

export function UrgentConcernsTemplate() {
  const { isFetching: isFetchingPending } = useUrgentConcernsWithOffline({
    status: UrgentConcernStatusEnum.PENDING,
  });
  const { isFetching: isFetchingResolved } = useUrgentConcernsWithOffline({
    status: UrgentConcernStatusEnum.RESOLVED,
  });

  if (isFetchingPending || isFetchingResolved) return <LoadingSpinner />;

  return (
    <View className="gap-6">
      <UrgentConcernsTable
        status={UrgentConcernStatusEnum.PENDING}
        title="Pending"
      />
      <UrgentConcernsTable
        status={UrgentConcernStatusEnum.RESOLVED}
        title="Resolved"
      />
    </View>
  );
}
